<app-site-header></app-site-header>
<app-toast-notification></app-toast-notification>
<router-outlet></router-outlet>
<app-loader></app-loader>
<app-site-footer></app-site-footer>
